<template>
  <div class="wc-layout wc-layout--desktop-default d-flex flex-column">
    <WCDesktopHeaderV2 />
    <WCPurchaseAgainModern
      v-if="isHomePage"
      id="home-purchase-again"
      class="wc-purchase-again-modern-desktop container"
      :entryMethod="entryMethodPurchaseAgain"
      data-testid="purchaseAgainRow"
    />
    <WCWebAdsModern
      v-if="webAds && webAds.length"
      class="container"
      :webAds="webAds"
      :key="this.webAdKey"
    />
    <section class="wc-layout__body container py-2 flex-grow-1">
      <WCAlertRoot />
      <slot>
        <router-view />
      </slot>
    </section>
    <WCFooter class="flex-shrink-0 mt-5" />
  </div>
</template>

<script>
import WCAlertRoot from '@/modules/alerts/components/WCAlertRoot/WCAlertRoot.vue';
import IneligibleCartCheckMixin from '@/mixins/IneligibleCartCheckMixin';
import { mapGetters } from 'vuex';
import WCWebAdsModern from '@/components/WCWebAdsModern/WCWebAdsModern.vue';
import WCFooter from '@/components/WCFooter/WCFooter.vue';
import WCDesktopHeaderV2 from '@/components/WCDesktopHeaderV2/WCDesktopHeaderV2.vue';
import WCPurchaseAgainModern from '@/views/Home/components/WCPurchaseAgainModern/WCPurchaseAgainModern.vue';
import { ENTRY_METHOD } from '@/models/entities/cart/entry-method';

export default {
  name: 'DesktopDefault',
  components: { WCDesktopHeaderV2, WCFooter, WCWebAdsModern, WCAlertRoot, WCPurchaseAgainModern },
  mixins: [IneligibleCartCheckMixin],
  computed: {
    ...mapGetters({ webAds: 'browse/getWebAds' }),
    webAdKey() {
      return JSON.stringify(this.webAds); // Needed to force WebAds to reload if new images are required.
    },
    entryMethodPurchaseAgain() {
      return ENTRY_METHOD.RECOMMENDATION_PURCHASE_AGAIN;
    },
    isHomePage() {
      return this.$route.name === 'Home';
    },
  },
};
</script>
<style lang="scss" scoped>
.wc-layout--desktop-default {
  min-height: 100%;
}

.wc-purchase-again-modern-desktop {
  margin-bottom: 1rem !important;
  margin-top: 0 !important;
  padding: 0 0.5rem !important;
}

.wc-layout__body {
  padding: 0 0.5rem !important;
}
</style>
